var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 22.3306V20.3306H18V22.3306H10ZM14 19.3306L10 15.3306L11.4 13.9306L13 15.5306V11.3556H15V15.5306L16.6 13.9306L18 15.3306L14 19.3306ZM2 18.3306C1.45 18.3306 0.979167 18.1347 0.5875 17.7431C0.195833 17.3514 0 16.8806 0 16.3306V2.33057C0 1.78057 0.195833 1.30973 0.5875 0.918066C0.979167 0.5264 1.45 0.330566 2 0.330566H9L15 6.33057V9.35557H8V18.3306H2ZM8 7.33057H13L8 2.33057V7.33057Z",
    fill: "#67768B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSave);
export default __webpack_public_path__ + "static/media/file_save.f99ff6af60cf5489af9f9ec14ab7ca6b.svg";
export { ForwardRef as ReactComponent };